/* global MicroModal */

const {KitModule, registerModule} = window;

class FormModal extends KitModule {
  constructor($element) {
    super($element);
    this.modalId = this.$element.getAttribute('data-modal-id');
    this.timerReveal = this.$element.getAttribute('data-timer-reveal');
    this.scrollReveal = this.$element.getAttribute('data-scroll-reveal');

    this.$element.addEventListener('click', this);

    this.scrollObserver();

    // opens modal if there is a timer
    if (this.timerReveal) {
      this.timeout = setTimeout(this.showModal.bind(this), this.timerReveal * 1000);
    }
  }

  onclick() {
    this.showModal();
  }

  scrollObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.showModal();
        }
      });
    });

    if (this.scrollReveal) {
      this.observer.observe(this.$element);
    }
  }

  showModal() {
    MicroModal.show(this.modalId, {
      awaitCloseAnimation: true,
      disableScroll: true,
    });

    this.observer.unobserve(this.$element);
    clearTimeout(this.timeout);
  }
}

registerModule('FormModal', FormModal);
